// Mirror of tailwind.config.js palette for recharts (Tailwind v3 emits no --color-* vars).
// If a theme/dark-mode switch lands later, promote these to CSS variables.
export const chartTokens = {
  primary: '#A3304D',
  accent: '#86243E',
  ok: '#246B46',
  warn: '#815B12',
  danger: '#B43328',
  qr: '#1B3A8A',
  ink3: '#68655F',
  line: '#E2DFD8',
} as const;

/** Ordered palette for multi-series charts (bars/slices). */
export const chartSeries: string[] = [
  chartTokens.primary,
  chartTokens.qr,
  chartTokens.ok,
  chartTokens.warn,
  chartTokens.accent,
  chartTokens.ink3,
];

/** Shared chart heights so the lazy skeleton matches the loaded chart (no CLS). */
export const CHART_H = { sm: 200, md: 260 } as const;
